export const statusTituloOption = [
  { label: 'Todos', value: 'ALL' },
  { label: 'Abertos', value: 'A' },
  { label: 'Fechados', value: 'F' },
];
